/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react'
import fetch from 'node-fetch'
import _get from 'lodash/get'

import MolaLayout from '@components/Molalayout'

import config from '@source/config'

import Home from './home-featured'

const title = 'Broadcaster Resmi Liga Inggris 2019-2022'
const description =
  'Live streaming Liga Inggris (EPL) di Mola TV secara online yang juga menayangkan Bundesliga, Carabao Cup, serta Film HBO, dan Movie Series terbaru lainnya'

async function action({ isMobile, store, pathname }) {
  const routes = 'home'

  const {
    endpoints: { domain },
    env,
  } = config

  return {
    id: 'home-new',
    title,
    description,
    chunks: ['home'],
    seo: async serverApi => {
      const headers = {
        host: serverApi.VIDEO_API_HOST,
        NREventType: 'Web/SEO' + '/home',
      }

      const rawResponse = await fetch(`${serverApi.VIDEO_API_URL}/playlists/home-new?app_id=${serverApi.appId}`, {
        timeout: 5000,
        maxRedirects: 1,
        headers,
      }).catch(e => console.log('SERVER SIDE RENDERING ', e))

      const response = rawResponse ? await rawResponse.json() : {}
      const seo = _get(response, 'data[0].attributes.seo', {
        title: '',
        imageUrl: '',
        description: '',
        keywords: [],
        tags: [],
      })
      const resizeImage = _get(response, 'data[0].attributes.ogImageLandscape', false)
        || _get(response, 'data[0].attributes.images.cover.landscape', `${domain}/mola.png`)
      return {
        title: seo.title,
        keywords: seo.keywords.length > 0 ? seo.keywords.join(' ') : '',
        description: seo.description || _get(response, 'data[0].attributes.description', description),
        // image: seo.imageUrl || `${domain}/mola.png`,
        image: `${resizeImage}?w=1200`,
        type: 'website',
        twitter_card_type: 'summary',
        appLinkUrl: '',
        url: domain,
      }
    },
    component: (
      <MolaLayout showNotif>
        <Home {...store} pathname={pathname} routes={routes} />
      </MolaLayout>
    ),
  }
}

export default action
